import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";

import BulkInvoiceUpload from "../bulkInvoice/BulkInvoiceUpload";
import BulkInvoicePreview from "../bulkInvoice/BulkInvoicePreview";
import BulkInvoiceProgress from "../bulkInvoice/BulkInvoiceProgress";
import { useInvoiceStyles } from "../styles";

/**
 * The three-step Excel flow. Kept together because the steps share one
 * piece of state (which step you are on) and nothing outside this file
 * needs to know about it.
 */
const BulkInvoiceFlow = ({
  step,
  file,
  rows,
  summary,
  progress,
  generating,
  result,
  auction,
  auctions,
  onAuctionChange,
  onParsed,
  onBack,
  onGenerate,
  onBackToPreview,
  onViewHistory,
}) => {
  const classes = useInvoiceStyles();

  return (
    <Box className={classes.bulkWrapper}>
      {step === 1 && (
        <BulkInvoiceUpload
          file={file}
          auctions={auctions}
          selectedAuction={auction}
          onAuctionChange={onAuctionChange}
          onBack={onBack}
          onParsed={onParsed}
        />
      )}

      {step === 2 && (
        <BulkInvoicePreview
          file={file}
          rows={rows}
          summary={summary}
          selectedAuction={auction}
          onBack={onBackToPreview}
          onGenerate={onGenerate}
        />
      )}

      {step === 3 && (
        <BulkInvoiceProgress
          rows={rows}
          file={file}
          selectedAuction={auction}
          externalProgress={progress}
          generating={generating}
          bulkResult={result}
          onBack={onBackToPreview}
          onViewHistory={onViewHistory}
        />
      )}
    </Box>
  );
};

BulkInvoiceFlow.propTypes = {
  step: PropTypes.number.isRequired,
  file: PropTypes.any,
  rows: PropTypes.array,
  summary: PropTypes.object,
  progress: PropTypes.number,
  generating: PropTypes.bool,
  result: PropTypes.object,
  auction: PropTypes.object,
  auctions: PropTypes.array,
  onAuctionChange: PropTypes.func.isRequired,
  onParsed: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
  onBackToPreview: PropTypes.func.isRequired,
  onViewHistory: PropTypes.func.isRequired,
};

BulkInvoiceFlow.defaultProps = {
  rows: [],
  auctions: [],
  progress: 0,
  generating: false,
};

export default BulkInvoiceFlow;
